import type { ComponentType } from 'react'
import ReactDOM from 'react-dom/client'

export function moveCaret(node: Element): void {
  const range = document.createRange()
  const selection = window.getSelection()

  if (!selection) return

  range.setStartAfter(node)
  range.collapse(true)
  selection.removeAllRanges()
  selection.addRange(range)
}

export function RenderReactComponent(
  Comp: ComponentType<any>,
  dom: HTMLElement,
  props?: Record<string, any>,
) {
  return ReactDOM.createRoot(dom).render(<Comp {...props} />)
}

export function insertElementToSelection(
  element: HTMLElement | DocumentFragment,
  container: HTMLDivElement,
  selectionInfo?: Record<string, any>,
) {
  const selection = selectionInfo || window.getSelection()
  // 检查是否有选中的文本
  if (!selection || !selection.rangeCount) return

  const range = selection.getRangeAt(0)

  // 创建两个新的 Range 对象，用于分割文本
  const rangeBefore = new Range()
  const rangeAfter = new Range()

  rangeBefore.setStart(container.firstChild!, 0)
  rangeBefore.setEnd(range.startContainer, range.startOffset)

  rangeAfter.setStart(range.endContainer, range.endOffset)
  rangeAfter.setEndAfter(container.lastChild!)

  // 提取分割后的内容
  const fragmentBefore = rangeBefore.extractContents()
  const fragmentAfter = rangeAfter.extractContents()

  // 清空 container 的内容，并重新添加拆分后的内容和新元素
  container.innerHTML = ''
  container.appendChild(fragmentBefore)
  container.appendChild(element)
  container.appendChild(fragmentAfter)
}

export function isSelectionInTargetNode(target: HTMLDivElement) {
  const selection = window.getSelection()
  if (!selection || !selection.rangeCount) return

  const range = selection.getRangeAt(0)
  const startContainer = range.startContainer
  const endContainer = range.endContainer

  // 检查选择区域的起始和结束节点是否都位于MarkdownIt容器内
  const inTargetContainer =
    target.contains(startContainer) && target.contains(endContainer)

  return inTargetContainer
}

export function getSelectionInfo(target: HTMLDivElement) {
  const inTargetContainer = isSelectionInTargetNode(target)
  const sel = window.getSelection()!
  if (inTargetContainer && sel?.rangeCount > 0) {
    return sel.getRangeAt(0).cloneRange()
  }
  return undefined
}
